import React from 'react';
import { GetReports } from '../../hooks/fetch-hooks/reports/get-reports';
import moment from 'moment';

const STATUS_STYLES = {
    PENDING: 'bg-yellow-100 text-yellow-700',
    PROCESSING: 'bg-blue-100 text-blue-700',
    DONE: 'bg-green-100 text-green-700',
    FAILED: 'bg-red-100 text-red-700',
};

export default function Reports() {
    const { data, isLoading, refetch } = GetReports();
    const reports = data?.data?.data || [];

    return (
        <div className='p-6 flex flex-col gap-4'>
            <div className='flex items-center justify-between'>
                <h1 className='text-xl font-semibold text-gray-800'>Reports</h1>
                <button
                    onClick={() => refetch()}
                    className='text-sm px-3 py-1.5 border border-gray-300 rounded-lg text-gray-600 hover:bg-gray-50'
                >
                    Refresh
                </button>
            </div>

            {isLoading ? (
                <p className='text-gray-400 text-sm'>Loading...</p>
            ) : reports.length === 0 ? (
                <p className='text-gray-400 text-sm'>No reports generated yet.</p>
            ) : (
                <div className='overflow-x-auto rounded-xl border border-gray-200'>
                    <table className='min-w-full bg-white'>
                        <thead>
                            <tr className='border-b border-gray-200 bg-gray-50'>
                                <th className='text-xs font-semibold text-gray-500 text-left px-4 py-3'>ID</th>
                                <th className='text-xs font-semibold text-gray-500 text-left px-4 py-3'>Type</th>
                                <th className='text-xs font-semibold text-gray-500 text-left px-4 py-3'>Status</th>
                                <th className='text-xs font-semibold text-gray-500 text-left px-4 py-3'>Rows</th>
                                <th className='text-xs font-semibold text-gray-500 text-left px-4 py-3'>Requested</th>
                                <th className='text-xs font-semibold text-gray-500 text-left px-4 py-3'>Completed</th>
                                <th className='text-xs font-semibold text-gray-500 text-left px-4 py-3'></th>
                            </tr>
                        </thead>
                        <tbody>
                            {reports.map((report) => (
                                <tr key={report.id} className='border-b border-gray-100 hover:bg-gray-50'>
                                    <td className='text-sm text-gray-700 px-4 py-3'>{report.id}</td>
                                    <td className='text-sm text-gray-700 px-4 py-3'>{report.type}</td>
                                    <td className='px-4 py-3'>
                                        <span className={`text-xs font-medium px-2 py-1 rounded-full ${STATUS_STYLES[report.status] || ''}`}>
                                            {report.status}
                                        </span>
                                    </td>
                                    <td className='text-sm text-gray-700 px-4 py-3'>{report.rowCount ?? '—'}</td>
                                    <td className='text-sm text-gray-500 px-4 py-3'>
                                        {moment(report.createdAt).format('DD MMM YYYY, HH:mm')}
                                    </td>
                                    <td className='text-sm text-gray-500 px-4 py-3'>
                                        {report.completedAt ? moment(report.completedAt).format('DD MMM YYYY, HH:mm') : '—'}
                                    </td>
                                    <td className='px-4 py-3'>
                                        {report.status === 'DONE' && report.downloadUrl ? (
                                            <a
                                                href={report.downloadUrl}
                                                target='_blank'
                                                rel='noreferrer'
                                                className='text-sm font-medium text-teal-600 hover:underline'
                                            >
                                                Download
                                            </a>
                                        ) : report.status === 'FAILED' ? (
                                            <span className='text-xs text-red-500'>{report.errorMessage || 'Failed'}</span>
                                        ) : (
                                            <span className='text-xs text-gray-400'>—</span>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
